import Utils from '../plugins/utils.js';

const expandedClass = 'stst-expanded';
const utils = new Utils();

class Toggle {
    constructor(toggler) {
        this.toggler = toggler;
        this.customToggleEvent = utils.customEventPolyfill('toggleSidebar');
    }

    hideUnder(that, hidePx, toggleElement) {
        if (window.innerWidth < hidePx) {
            that.toggler.setAttribute('aria-expanded', 'false');

            if (toggleElement.classList.contains(expandedClass)) {
                toggleElement.classList.remove(expandedClass);
            }
        } else {
            that.toggler.setAttribute('aria-expanded', 'true');

            if (!toggleElement.classList.contains(expandedClass)) {
                toggleElement.classList.add(expandedClass);
            }
        }

        setTimeout(() => {
            window.dispatchEvent(that.customToggleEvent);
        }, 750);
    }

    handleToggle() {
        const ariaControls = this.toggler.getAttribute('aria-controls');

        if (typeof ariaControls === 'undefined') {
            return;
        }

        const toggleElement = document.getElementById(ariaControls);

        if (toggleElement === null) {
            return;
        }

        const initialAriaExpanded = this.toggler.getAttribute('aria-expanded');

        if (typeof initialAriaExpanded === 'undefined') {
            this.toggler.setAttribute('aria-expanded', 'false');
        }

        this.toggler.addEventListener('click', evt => {
            evt.preventDefault();
            evt.stopPropagation();
            const ariaExpanded = this.toggler.getAttribute('aria-expanded');

            if (ariaExpanded === 'false') {
                this.toggler.setAttribute('aria-expanded', 'true');

                if (!toggleElement.classList.contains(expandedClass)) {
                    toggleElement.classList.add(expandedClass);
                }
            } else {
                this.toggler.setAttribute('aria-expanded', 'false');

                if (toggleElement.classList.contains(expandedClass)) {
                    toggleElement.classList.remove(expandedClass);
                }
            }

            setTimeout(() => {
              window.dispatchEvent(this.customToggleEvent);
            }, 750);
        });

        if (typeof this.toggler.dataset.togglerHideUnder !== 'undefined') {
            const hidePx = parseInt(this.toggler.dataset.togglerHideUnder);
            this.hideUnder(this, hidePx, toggleElement);

            window.addEventListener('resize', () => {
              this.hideUnder(this, hidePx, toggleElement);
            }, false);
        }
    }

    init() {
        this.handleToggle();
    }
}

export default Toggle;
